<template>
  <div class="px-8 mt-4">
    <v-dialog
      v-model="prViewItemDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="prModal"
      scrollable
    >
      <v-card>
        <v-toolbar max-height="65" dark color="green darken-2">
          <v-toolbar-title>{{prcData.PRCCODE}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn outlined @click="viewRemarks()" class="mr-5"><v-icon class="mr-2">mdi-email</v-icon>Messages</v-btn> -->
          <v-btn icon dark @click="clickCloseMainDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-----Header----->
        <v-card-text style="max-height: 2000px;">
        <div>
          <v-row class="mt-4">
            <v-col cols="12" class="d-flex justify-center">
              <v-subheader class="font-weight-bold text-h6">Consolidated Purchase Requests</v-subheader
              >
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-5">
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Entity Name:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>Davao del Norte State College</v-subheader>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Fund Cluster:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ prcData.FundCode }}</v-subheader>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">PR No.:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{prcData.PRCCODE}}</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader class="font-weight-bold">Date Created:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-subheader>{{ prcData.DateCreated }}</v-subheader>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-5">
            <v-col cols="12" md="3">
              <v-subheader class="font-weight-bold">Purpose:</v-subheader>
            </v-col>
            <v-col cols="12" md="3">
              <v-subheader>{{prcData.PRCPurpose}}</v-subheader>
            </v-col>
            <v-col cols="12" md="3">
              <v-subheader class="font-weight-bold">GRAND TOTAL:</v-subheader>
            </v-col>
            <v-col cols="12" md="3">
              <v-subheader>₱ {{formatPrice(GrandTotal || 0)}}</v-subheader>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col lg="12" class="py-4">
            <v-card class="">
              <v-data-table
                :loading="loading_pr"
                :headers="headers_pr"
                :items="itemList_pr"
                :options.sync="options_pr"
                :server-items-length="totalCount_pr"
                :footer-props="footerProps"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <span class="green--text text--darken-2"
                      >List Of Purchase Requests</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      color="secondary"
                      outlined
                      class="mr-2"
                      small
                      dark
                      @click="editPRC()"
                      v-if="$store.state.user.roleID == 5 && prcData.IsCancelled == 0"
                    >
                    <v-icon class="mr-1">mdi-pencil</v-icon>
                      Edit PRC
                    </v-btn>
                    
                    <v-btn
                      outlined
                      color="red darken-2"
                      dark
                      small
                      @click="print(prcData)"
                      class="mr-2"
                      v-if="prcData.IsCancelled == 0"
                    >
                      <v-icon>print</v-icon>
                      Print
                    </v-btn>
                    <v-btn
                      color="red darken-2"
                      class="white--text"
                      small
                      dark
                      @click="unpublish(prcData.PRCID)"
                      v-if="
                        $store.state.user.roleID == 5 && unpublishBtn && prcData.IsCancelled == 0
                      "
                    >
                      UNPUBLISH
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.GrandTotal`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.GrandTotal) }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      x-small
                      outlined
                      color="blue darken-2"
                      dark
                      class="mr-2"
                      @click="viewPR(item)"
                    >
                      VIEW
                    </v-btn>
                </template>
              </v-data-table>
            </v-card>
            <v-divider class="my-5"></v-divider>
            <v-card class="">
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="itemList"
                :options.sync="options"
                :server-items-length="totalCount"
                :footer-props="footerProps"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <span class="green--text text--darken-2"
                      >List Of Items</span
                    >
                    <v-spacer></v-spacer>
                    <vue-json-to-csv 
                    :json-data="itemListForCSV"
                    :labels="{ 
                      ItemName: { title: 'Item Name' },
                      itemDescription: { title: 'Item Description' },
                      Qty: { title: 'Quantity' },
                      UnitMeasureDescription: { title: 'Unit Measure' },
                      UnitCost: { title: 'Unit Cost' },
                      }"
                    :csv-title="prcData.PRCCODE || prcData.PRCCODETemp">
                      <v-btn
                        outlined
                        small
                        color="green darken-2"
                        dark
                        class="mr-2"
                        :loading="loadingCSV"
                      >
                        <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
                        CSV
                      </v-btn>
                    </vue-json-to-csv>
                    <vue-json-to-csv
                    v-if="prcData.isParent"
                    :json-data="summaryForCSV"
                    :labels="{ 
                      Office: { title: 'Office' },
                      EndUser: { title: 'End User' },
                      BudgetCode: { title: 'BudgetCode' },
                      Unit: { title: 'Unit' },
                      ItemName: { title: 'Item Name' },
                      ItemDescription: { title: 'Item Description' },
                      Qty: { title: 'Qty' },
                      UnitCost: { title: 'Unit Cost' },
                      total: { title: 'Total' },
                      }"
                    :csv-title="prcData.PRCCODE || prcData.PRCCODETemp">
                    <v-btn
                        small
                        color="green darken-2"
                        dark
                        class="mr-2"
                        :loading="loadingSummary"
                      >
                        <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
                        Summary
                      </v-btn>
                    </vue-json-to-csv>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.UnitCost`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost || 0) }}</span>
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  <span class="text-no-wrap">₱ {{formatPrice(parseFloat(item.UnitCost) * parseFloat(item.Qty))}}</span>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPending" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">Pending Purchase Request</span>
          <v-spacer></v-spacer>
          <v-btn icon dark color="secondary2" @click="dialogPending = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form @submit.prevent ref="formRef">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    color="green"
                    dense
                    v-model="remarks"
                    :rules="[formRules.required]"
                    label="Remarks"
                    counter
                    maxlength="500"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogPending = false">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="confirmReturn()">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogApprove" max-width="500px">
      <v-card>
        <v-card-title class="text-h6"
          >Are you sure you want to approve this PR?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-2" text @click="dialogApprove = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-2" @click="confirmApprove()" text
            >Yes</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card>
        <v-card-actions>
          <v-row justify="center">
            <v-col align="center" cols="12">
              <v-icon dense x-large color="red darken-2" class="mt-4"
                >mdi-help-circle-outline</v-icon
              >
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-title class="text-h6 d-flex justify-center"
          >Are you sure you want to UNPUBLISH this PRC?</v-card-title
        >
        <v-card-actions class="mt-4">
          <v-row justify="center">
            <v-col align="center" cols="6">
              <v-spacer></v-spacer>
              <v-btn color="red darken-2" text @click="dialogConfirm = false"
                >Cancel</v-btn
              >
            </v-col>
            <v-col align="center" cols="6">
              <v-spacer></v-spacer>
              <v-btn color="green darken-2" text @click="confirmUnpublish()"
                >Continue</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="EditPRCDialog"
        persistent
        max-width="1200px"
        scrollable
      >
        <v-card>
          <v-card-title>
            <span class="">Edit Consolidated Purchase Requests</span>
            <v-spacer></v-spacer>
             <v-btn icon @click="EditPRCDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-card-title>
          <v-card-text style="max-height: 900px">
            <div class="pa-4">
              <v-form @submit.prevent ref="FormrefEditPRC">
              <v-row>
              <v-col cols="12">
                <v-textarea
                    v-model="formData.PRCPurpose"
                    color="green darken-2"
                    :rules="[formRules.required]"
                    dense
                    outlined
                    label="Purpose"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
              <v-data-table
                :loading="loading"
                :headers="headers_pr"
                :items="itemList_edit"
                class="elevation-2"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <span class="green--text text--darken-2"
                      >List Of Purchase Requests</span
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.GrandTotal`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.GrandTotal) }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      color="red darken-3"
                      class="mr-2 white--text"
                      x-small
                      @click="deleteItem(item)"
                      :disabled="itemList_edit.length <= 2"
                    >
                    <v-icon class="mr-1" x-small>mdi-delete</v-icon>
                      Remove
                    </v-btn>
                </template>
              </v-data-table>
                </v-col>

              <v-col cols="12" v-if="itemList_delete.length > 0">
              <v-data-table
                :loading="loading"
                :headers="headers_pr"
                :items="itemList_delete"
                class="elevation-2"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <span class="red--text text--darken-2"
                      >List Of Deleted Purchase Requests</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-2"
                      class="mr-2 white--text"
                      small
                      @click="restoreAllItems()"
                      :disabled="itemList_delete.length <= 1"
                    >
                    <v-icon class="mr-1">mdi-delete-restore</v-icon>
                      Restore All
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.GrandTotal`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.GrandTotal) }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      color="red darken-3"
                      outlined
                      class="mr-2 white--text"
                      x-small
                      @click="restoreItem(item)"
                    >
                    <v-icon class="mr-1" x-small>mdi-delete-restore</v-icon>
                      Restore
                    </v-btn>
                </template>
              </v-data-table>
                </v-col>
              </v-row> 
                </v-form>
            </div>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              outlined
              @click="EditPRCDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-2 white--text"
              @click="updatePRC()"
            >
            <v-icon class="mr-1">mdi-check-circle-outline</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <v-dialog
          v-model="confirmationDialog"
          persistent
          max-width="450px"
        >
          <v-card>
            <v-card-title>
              <span class="">Confirmation</span>
            </v-card-title>
            <v-card-text>
              {{confirmationMessage}}
              <div v-if="itemList_delete.length > 0 && confirmType == 1">
              <div class="mt-3">
              <b>Deleted PRs: </b> 
              <ul>
                <li v-for="(item, index) in itemList_delete" :key="index">
                  {{ item.PRCODE}}
                </li>
              </ul>
            </div>
            <div class="mt-3" v-if="itemList_delete.length > 0">
            <i><strong>Note: </strong>All deleted PRs will be permanently removed to this Consolidated ;Purchase Request.</i>
            </div>
            </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                outlined
                @click="confirmationDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="green darken-2"
                class="white--text"
                @click="confirmUpdatePRC()"
                v-if="confirmType == 1"
              >
              <v-icon>mdi-check-circle-outline</v-icon>
                Update
              </v-btn>
              <v-btn
                color="red darken-2"
                class="white--text"
                @click="confirmDeleteItem()"
                v-if="confirmType == 2"
              >
              <v-icon>mdi-delete</v-icon>
                Remove
              </v-btn>
              <v-btn
                color="red darken-2"
                class="white--text"
                @click="confirmRestoreItem()"
                v-if="confirmType == 3"
              >
              <v-icon>mdi-restore</v-icon>
                Restore
              </v-btn>
              <v-btn
                color="red darken-2"
                class="white--text"
                @click="confirmRestoreAllItems()"
                v-if="confirmType == 4"
              >
              <v-icon>mdi-restore</v-icon>
                Restore All
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>

    <prModal :prData="prItem" />
  </div>
</template>
    
    <script>
export default {
  components: {
    prModal: () => import("./PRViewItem"),
  },
  props: {
    prcData: {},
  },
  data: () => ({
    prDetails: [],
    remarks: null,
    headers: [
      {
        text: "Item Name",
        align: "start",
        sortable: false,
        value: "ItemName",
      },
      { text: "Description", value: "itemDescription", sortable: false },
      { text: "Quantity", value: "Qty", sortable: false },
      { text: "Unit Meas.", value: "UnitMeasureDescription", sortable: false },
      { text: "Unit Cost", value: "UnitCost", sortable: false },
      { text: "Amount", value: "Amount", sortable: false },
    ],
    headers_pr: [
      {
        text: "PR No.",
        align: "start",
        sortable: false,
        value: "PRCODE",
      },
      {
        text: "Budget Code",
        value: "BudgetCode",
        sortable: false,
      },
      {
        text: "PR Purpose",
        value: "PrPurpose",
        sortable: false,
      },
      {
        text: "PR Date",
        value: "DateCreated",
        sortable: false,
      },
      {
        text: "Grand Total",
        value: "GrandTotal",
        sortable: false,
        align: "end",
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
     headers_edit: [
      {
        text: "Item Name",
        align: "start",
        sortable: false,
        value: "ItemName",
      },
      { text: "Description", value: "itemDescription", sortable: false },
      { text: "Quantity", value: "Qty", sortable: false },
      { text: "Unit Meas.", value: "UnitMeasureDescription", sortable: false },
      { text: "Unit Cost", value: "UnitCost", align: 'end', sortable: false },
      { text: "Amount", value: "amount", align: 'end', sortable: false },
      { text: "Action", value: "action", align: 'center', sortable: false },
    ],
    headers_delete: [
      {
        text: "Item Name",
        align: "start",
        sortable: false,
        value: "ItemName",
      },
      { text: "Description", value: "itemDescription", sortable: false },
      { text: "Quantity", value: "Qty", sortable: false },
      { text: "Unit Meas.", value: "UnitMeasureDescription", sortable: false },
      { text: "Unit Cost", value: "UnitCost", align: 'end', sortable: false },
      { text: "Amount", value: "amount", align: 'end', sortable: false },
      { text: "Action", value: "action", align: 'center', sortable: false },
    ],
    loading: false,
    loading_pr: false,
    prViewItemDialog: false,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    totalCount_pr: 0,
    options: {},
    options_pr: {},
    isLoading: false,
    itemList: [],
    itemList_pr: [],
    itemList_edit: [],
    itemList_delete: [],
    item: null,
    dialogPending: false,
    dialogApprove: false,
    dialogConfirm: false,
    unpublishBtn: false,
    toUnpublishPRCID: null,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Added!",
      message: "",
      top: 10,
    },
    loadingCSV: false,
    itemListForCSV: [],
    EditPRCDialog: false,
    confirmationDialog: false,
    dialogConfirmUpdate: false,
    itemToDelete: [],
    itemToRestore: [],
    confirmationMessage: '',
    confirmType: null,
    prItem: {},
    poList: [],
    footerProps2: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount2: 0,
    loading2: true,
    searchText: '',
    options2: {},
    formData: {
      PRCPurpose: null,
    },
    filelist: [],
    filelist_uploaded: [],
    filelist_deleted: [],
    loadingSummary: true,
    summaryForCSV: [],
    GrandTotal: 0,
  }),
  watch: {
    options: {
      handler() {
        if (this.totalCount > 0) {
          this.getItems();
        }
      },
      deep: true,
    },
    options_pr: {
      handler() {
        if (this.totalCount_pr > 0) {
          this.getPRList();
        }
      },
      deep: true,
    },
    options2: {
      handler() {
        this.getPOs();
      },
      deep: true,
    },
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getPOs();
      }, 600);
    },
    prcData: {
      handler(data) {
        if (data.PRCID) {
          this.prViewItemDialog = true;
          this.getPRList();
          if(data.isParent == 1){
            this.getSummaryForCSV();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
        this.eventHub.$on("closePOItemodal", () => {
          this.getPOs();
        });
        this.eventHub.$on("closePRItemodal", () => {
          this.prItem = {};
          this.getPRList();
        });
  },
  beforeDestroy() {
         this.eventHub.$off("closePOItemodal");
         this.eventHub.$off("closePRItemodal");
    },
  methods: {
    viewPR(item) {
      this.prItem = item;
    },
    getPOs() {
      this.loading2 = true;
      let data = new FormData();
      if (this.options2.page) {
        data.append("page", this.options2.page);
        data.append("itemsPerPage", this.options2.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      // data.append("tab", this.tab);
      data.append("PRCID", this.prcData.PRCID);
      data.append("searchText", this.searchText);
      // data.append("OfficeID", 0);
      // data.append("DeliveryUnitID", 0);
      // data.append("PurposeID", 0);
      // data.append("SpecificFundSourceID", 0);
      this.axiosCall("/pr/relatedPO", "POST", data).then((res) => {
        this.loading2 = false;
        this.poList = res.data.data.result;
        this.totalCount2 = res.data.data.total;
        if (this.totalCount2 <= 10) {
          this.options2.page = 1;
        }
      });
    },
    approveItem(data) {
      this.item = data;
      this.dialogApprove = true;
    },
    pendingItem(data) {
      this.item = data;
      this.dialogPending = true;
    },
    confirmReturn() {
      if (this.$refs.formRef.validate()) {
        let data = new FormData();
        data.append("Remarks", this.remarks);
        data.append("PRCID", this.item.PRCID);
        this.axiosCall("/signatories/pr/pending", "POST", data).then((res) => {
          console.log(res);
          this.clickCloseMainDialog();
        });
      }
    },
    confirmApprove() {
      let data = new FormData();
      data.append("PRCID", this.item.PRCID);
      this.axiosCall("/signatories/pr/approve", "POST", data).then((res) => {
        console.log(res);
        this.clickCloseMainDialog();
      });
    },
    clickCloseMainDialog() {
      this.dialogPending = false;
      this.dialogApprove = false;
      this.totalCount = 0;
      this.totalCount_pr = 0;
      this.prViewItemDialog = false;
      this.remarksData = [];
      this.itemList_delete = [];
      // this.searchText = '';
      // this.options2 = [];
      // this.poList = [];
      // this.totalCount2 = 0;
      this.filelist_uploaded = [];
      this.filelist_deleted = [];
      this.eventHub.$emit("closePRItemodal", false);
      this.eventHub.$emit("closePRItemodal1", false);
    },
    print(data) {
      window.open(this.apiUrl + "/pr/report/" + data.PRCID);
    },
    getPRList() {
      this.unpublishBtn = false;
      let data = new FormData();
      if (this.options_pr.page) {
        data.append("page", this.options_pr.page);
        data.append("itemsPerPage", this.options_pr.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("PRCID", this.prcData.PRCID);
      this.axiosCall("/prc/ViewPRList", "POST", data).then((res) => {
        this.loading = false;
        this.itemList_pr = res.data.data.result;
        this.itemList_edit = res.data.data.result;
        this.totalCount_pr = res.data.data.total;
        if (this.totalCount_pr <= 10) {
          this.options_pr.page = 1;
        }
        this.itemList_pr.forEach(item => {
          this.GrandTotal += parseFloat(item.GrandTotal);
        });
        // this.ppmpUsedAmount = parseFloat((res.data.data.useAmount).toFixed(2));
        this.getItems();
      });
    },
    getItems() {
      this.unpublishBtn = false;
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      let prids = [];
      this.itemList_pr.forEach(item => {
          prids.push(item.PRID)
        });
      data.append("PRIDS", prids.join(','));
      this.axiosCall("/prc/ViewPRItems", "POST", data).then((res) => {
        this.loading = false;
        this.prDetails = res.data.data.details;
        this.itemList = res.data.data.result;
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
        this.ableToUnpublish();
        this.getDataForCSV();
      });
    },
    unpublish(PRCID) {
      this.dialogConfirm = true;
      this.toUnpublishPRCID = PRCID;
    },
    ableToUnpublish() {
      this.unpublishBtn = false;
        this.itemList.forEach(item => {
          if (item.PRID != 0 && item.PRstatus != 3 && item.PRstatus != 4) {
            console.log(true)
          this.unpublishBtn = true;
        }
        console.log(false)
        });
    },
    confirmUnpublish(){
      let data = new FormData();
      data.append("PRCID", this.toUnpublishPRCID);
      this.axiosCall("/prc/unpublish", "POST", data).then((res) => {
        if(res.data.status) {
            this.toUnpublishPPMPID = null;
            this.dialogConfirmUnpublish = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'success';
            this.fadeAwayMessage.message = 'Consolidated Purchase Request successfully unpublished!';
            this.fadeAwayMessage.header = 'System Message';
            this.dialogConfirm = false;
            this.prViewItemDialog = false;
            }else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'error';
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = 'System Message';
            }
      });
    },
    getDataForCSV(){
      this.loadingCSV = true;
      let data = new FormData();
      data.append("PRCID", this.prcData.PRCID);
      this.axiosCall("/csv/getItemsByPRCID", "POST", data).then((res) => {
        this.loadingCSV = false;
        this.itemListForCSV = res.data.data.result;
      });
    },
    getSummaryForCSV(){
      this.loadingSummary = true;
      let data = new FormData();
      data.append("PRCID", this.prcData.PRCID);
      this.axiosCall("/csv/getSummaryByPRCID", "POST", data).then((res) => {
        this.loadingSummary = false;
        this.summaryForCSV = res.data.data;
      });
    },
    editPRC(){
      this.formData.PRCPurpose = this.prcData.PRCPurpose;
      this.EditPRCDialog = true;
    },
    deleteItem(data){
      this.confirmType = 2;
      this.confirmationMessage = "Are you sure you want to remove this Purchase Request?"
      this.itemToDelete = data;
      this.confirmationDialog = true;
    },
    restoreItem(data){
      this.confirmType = 3;
      this.confirmationMessage = "Are you sure you want to restore this Purchase Request?"
      this.itemToRestore = data;
      this.confirmationDialog = true;
    },
    restoreAllItems(){
      this.confirmType = 4;
      this.confirmationMessage = "Are you sure you want to restore all Purchase Requests?"
      this.confirmationDialog = true;
    },
    updatePRC(){
      this.confirmType = 1;
      this.confirmationMessage = "Are you sure you want to update this Consolidated Purchase Request?"
      this.confirmationDialog = true;
    },
    confirmUpdatePRC(){
      let data = new FormData();
      data.append("PRCID", this.prcData.PRCID);
      data.append("Purpose", this.formData.PRCPurpose);
      data.append('List', JSON.stringify(this.itemList_edit));
      data.append('deleteList', JSON.stringify(this.itemList_delete));
      this.axiosCall("/prc/update", "POST", data).then((res) => {
        if(res.data.status) {
            this.confirmationDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'success';
            this.fadeAwayMessage.message = 'Consolidated Purchase Request successfully updated!';
            this.fadeAwayMessage.header = 'System Message';
            this.EditPRCDialog = false;
            this.itemList_delete = [];
            this.prcData.PRCPurpose = this.formData.PRCPurpose;
            this.getPRList();
            this.filelist_deleted = [];
            this.filelist = [];
            }else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'error';
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = 'System Message';
            }
      });
    },
    uploadFiles(){
      let data = new FormData();
      this.filelist.forEach((item, i) => {
        if(!item.PRCID){
        data.append('files['+i+']', item || '');
        }
      });
      data.append("PRCID", this.prcData.PRCID);
      if(this.filelist_deleted.length > 0){
      data.append("files_deleted", JSON.stringify(this.filelist_deleted));
      }
      this.axiosCall(
              '/upload/pr/attachment',
              'POST',
              data
          )
          .then((res) => {
              if (res.data.status){
                this.getAttachmentsByPRCID();
              }
              else{
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = 'error';
              this.fadeAwayMessage.message = res.data.message;
              this.fadeAwayMessage.header = 'System Message';
              }
          })
    },
    confirmDeleteItem(){
      let index = this.itemList_edit.indexOf(this.itemToDelete);
      if (index > -1) {
        this.itemList_edit.splice(index, 1);
        this.itemList_delete.push(this.itemToDelete);

        this.confirmationDialog = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "success";
        this.fadeAwayMessage.message = "Item Successfully Added to the trash!";
        this.fadeAwayMessage.header = "System Message";
      }
    },
    confirmRestoreItem(){
      let index = this.itemList_delete.indexOf(this.itemToRestore);
      if (index > -1) {
        this.itemList_delete.splice(index, 1);
        this.itemList_edit.push(this.itemToRestore);

        this.confirmationDialog = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "success";
        this.fadeAwayMessage.message = "Item Successfully restored!";
        this.fadeAwayMessage.header = "System Message";
      }
    },
    confirmRestoreAllItems(){
       this.itemList_delete.forEach(item => {
        this.itemList_edit.push(item);
       });
        this.itemList_delete = [];
        this.confirmationDialog = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "success";
        this.fadeAwayMessage.message = "All Items Successfully restored!";
        this.fadeAwayMessage.header = "System Message";
    },
    onChange() {
      if((this.$refs.file.files.length + this.filelist_uploaded.length) > 5){
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Maximum of 5 PDF files are allowed.";
        this.filelist = [];
      }
      else{
        this.filelist = [...this.$refs.file.files];
      }
      },
      preview(file) {
        window.open(URL.createObjectURL(file));
      },
      preview_old(file) {
        // console.log(file)
        window.open(this.apiUrl + '/attachment/' + file.id, '_blank');
      },
      remove(i) {
        this.filelist.splice(i, 1);
      },
      remove_old(i){
        this.filelist_deleted.push(this.filelist_uploaded[i]);
        this.filelist_uploaded.splice(i, 1);
      },
      revert_old(i){
        this.filelist_uploaded.push(this.filelist_deleted[i]);
        this.filelist_deleted.splice(i, 1);
      },
      dragover(event) {
        event.preventDefault();
        if (!event.currentTarget.classList.contains('bg-green-300')) {
          event.currentTarget.classList.remove('bg-gray-100');
          event.currentTarget.classList.add('bg-green-300');
        }
      },
      dragleave(event) {
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
      },
      drop(event) {
        event.preventDefault();
        this.$refs.file.files = event.dataTransfer.files;
        if((event.dataTransfer.files.length + this.filelist_uploaded.length) > 5){
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = "Maximum of 5 PDF files are allowed.";
        }
        else{
          this.onChange();
        }
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
      },
      
  },
};
</script>
        
    <style scoped>
.v-dialog--fullscreen,
.prModal {
  overflow-x: hidden !important;
}
.dividerClass {
   border-width: 1px !important;
}
.dd-container {
  background-color: white !important;
  border: 3px dashed green !important;
}
.dd-container2 {
  background-color: white !important;
  border: 2px solid green !important;
}
</style>